import { capitalize, find, flatten, isArray, isEmpty, mapValues, values } from 'lodash'
import { mapActions, mapState } from 'vuex'
import { ADD_TOAST_MESSAGE } from 'vuex-toast'

import moment from 'moment'
import str_is from 'str-is'

// import * as Permissions from '../permissions'
import * as Constants from '@/constants'
import * as Types from '@/store/types'
import { acronym, addressFormat, blobToJson, defaulted, getApiUrl, nl2br, numberFormat, phoneNumber } from '@/helpers'

const calendar       = (value) => moment(value).calendar()
const dateFormat     = (value, format=Constants.DATE_FORMAT) => moment(value).format(format)
const dateTimeFormat = (value, format=Constants.DATE_TIME_FORMAT) => dateFormat(value, format)

export default
{
	data()
	{
		return {
			isError: false,
			isReady: false,
		}
	},

	errorCaptured(err, vm, info)
	{
		//this.isError = true
	},

	computed:
	{
		...mapState
		({
			isLoading: state => state.loading?.is_loading,
		}),

		...mapValues
		(
			Constants,
			(value, key) => { return () => value }
		),

		// 'Permissions': () => Permissions,
		'Types':       () => Types,
	},

	filters:
	{
		acronym,
		addressFormat,
		calendar,
		capitalize,
		dateFormat,
		dateTimeFormat,
		nl2br,
		numberFormat,
		phoneNumber,

		'default': defaulted,
	},

	methods:
	{
		acronym,
		addressFormat,
		calendar,
		capitalize,
		dateFormat,
		dateTimeFormat,
		getApiUrl,
		moment,
		nl2br,
		numberFormat,
		phoneNumber,

		'default': defaulted,

		isRoute(...patterns)
		{
			const { name } = this.$route ?? {}

			return name && flatten(patterns).some(pattern => str_is(pattern, name))
		},

		async catchError(error)
		{
			let message

			if ( error.response )
			{
				if ( error.response.data )
				{
					if ( error.request && error.request.responseType === 'blob' )
					{
						error.response.data = await blobToJson(error.response.data)
					}

					message = error.response.data.message

					if ( error.response.data.errors )
					{
						message = flatten(values(error.response.data.errors))

						if ( isArray(message) )
						{
							message = message.shift()
						}
					}
				}

				message = message || error.response.statusText
			}
			else if ( error.request )
			{
				message = 'Request error, check console'
			}
			else
			{
				message = error.message
			}

			this.sendNotification(message, 'danger')

			//this.isError = true
		},

		...mapActions
		({
			addToast: ADD_TOAST_MESSAGE,
		}),

		sendNotification(text, type='success', dismissAfter=10000)
		{
			this.addToast({ text, type, dismissAfter })
		},

		sendErrorNotification(text, dismissAfter=10000)
		{
			return this.sendNotification(text, 'danger', dismissAfter)
		},
	},
}